module.exports = __webpack_public_path__ + "media/images/event_footer_sp-65c80364d42549b2a53e27bbf63a0c4e.png";